import { Dashboard } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import api from 'api/api';
import { compose } from 'ramda';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { OrganizationType } from 'store/modules/organizations/organizations';
import Users from 'components/OrganizationAdmin/Products/Shared/Users';
import Menu, { Tab } from './Menu';
import { BackTo } from '@deeptrue-frontend/ui';
import ROUTES from 'consts/routing';
import Groups from 'components/OrganizationAdmin/Products/Shared/Groups';
import { ProductType } from '../types';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors } = StoreProvider;

interface Props extends RouteComponentProps {
  organization: OrganizationType;
  match: {
    isExact: boolean;
    path: string;
    url: string;
    params: {
      id: string;
    };
  };
}

const ProductSharingPage = ({
  location,
  organization,
  match,
  history,
}: Props) => {
  const t = useFormatMessage();
  const [tab, selectTab] = useState<Tab>(
    location.search === '?tab=users' ? 'users' : 'groups'
  );
  const [product, setProduct] = useState<ProductType>({
    id: null,
    name: '',
    shared_to_groups: [],
    shared_to_users: [],
    workbench: {
      id: null,
      name: '',
    },
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const { id } = match.params;

  const getProduct = () =>
    api.resources.organization.products
      .getProduct({
        organizationCodename: organization.codename,
        id: id,
      })
      .then(({ data }: { data: ProductType }) => {
        setProduct({ ...data });
      })
      .finally(() => {
        setIsLoaded(true);
      });

  useEffect(() => {
    getProduct();
    // eslint-disable-next-line
  }, []);

  return (
    <Dashboard title={`Admin / ${product.name}`} location={location}>
      <BackTo onClick={() => history.push(ROUTES.ORGANIZATION.ADMIN.PRODUCTS)}>
        <span>
          {`${t('organization.backTo', 'Back to')} ${t(
            'organization.products',
            'Products'
          )}`}
        </span>
      </BackTo>
      <Menu tab={tab} selectTab={selectTab} />
      {tab === 'users' && (
        <Users
          organizationCodename={organization.codename}
          productData={product}
          isLoaded={isLoaded}
          refreshProduct={getProduct}
        />
      )}
      {tab === 'groups' && (
        <Groups
          organizationCodename={organization.codename}
          productData={product}
          isLoaded={isLoaded}
          refreshProduct={getProduct}
        />
      )}
    </Dashboard>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
    isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
  }))
)(ProductSharingPage);
